import "../chunk-3W5G4CYI.js";
import { createDevOrStagingUrlCache } from "@clerk/shared/keys";
const { isDevOrStagingUrl } = createDevOrStagingUrlCache();
export {
  isDevOrStagingUrl
};
//# sourceMappingURL=isDevOrStageUrl.js.map